import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found | Mood Food Recommender';
  }, []);

  return (
    <div className="text-center py-16">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page not found</p>
      <Link to="/" className="inline-block bg-gray-800 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-700 transition">
        Back to Home
      </Link>
    </div>
  );
}

export default NotFound;
